<template>
  <svg
    class="app-os-icon"
    :class="extraClass"
    :width="size"
    :height="size"
    :viewBox="viewBox"
    :aria-hidden="decorative ? 'true' : 'false'"
    :role="decorative ? null : 'img'"
    focusable="false"
  >
    <title v-if="!decorative && title">{{ title }}</title>
    <use :href="spriteHref" />
  </svg>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  symbol: {
    type: String,
    default: 'other'
  },
  size: {
    type: [Number, String],
    default: 20
  },
  title: {
    type: String,
    default: ''
  },
  decorative: {
    type: Boolean,
    default: true
  },
  extraClass: {
    type: String,
    default: ''
  },
  viewBox: {
    type: String,
    default: '0 0 256 256'
  }
})

const spriteHref = computed(() => `/images/svg/sprite.svg#${props.symbol || 'other'}`)
</script>
